/* Caipi Redesign — PDP "Anbau-Helfer" interactions.
   Vanilla, dependency-free. Add-to-cart + drawer are handled by Canopy's
   <product-form> web component; this only wires gallery, qty stepper
   (syncing the form's quantity input + live total) and timeline focus. */
(function () {
  'use strict';

  function euro(cents) {
    return (cents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + ' €';
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function truncateWords(str, n) {
    var words = String(str || '').split(/\s+/);
    return words.length > n ? words.slice(0, n).join(' ') + '…' : str;
  }

  function sizedImage(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* --- Vorbestellung (Timesact Pre-Order): Lieferzeit-Hinweis nativ rendern ---
     Die Timesact-App benennt den Warenkorb-Button um + injiziert den Selling-Plan,
     platziert ihre Lieferzeit-Nachricht aber an einem Alt-Theme-Anker
     (.product-info__add-to-cart), den dieses Redesign nicht hat — daher fiel der
     Hinweis aus. Wir lesen dieselben App-Daten aus localStorage und rendern den
     Hinweis deterministisch in die Kaufbox. Auflösung 1:1 wie die App
     (populateDynamicValues + Versanddatum), Quelle bleibt die App-Config → synchron. */
  function taParse(key) { try { return JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) { return null; } }

  function taVariantConfig(prods, pid, variantId) {
    variantId = String(variantId || '');
    if (!prods || !variantId) return null;
    var p = (pid && prods[pid]) ? prods[pid] : null;
    if (p && p.variants && p.variants[variantId]) return p.variants[variantId];
    for (var k in prods) { var q = prods[k]; if (q && q.variants && q.variants[variantId]) return q.variants[variantId]; }
    return null;
  }

  function taFmtDate(ts) {
    return new Date(ts * 1000).toLocaleDateString('de-DE', { day: 'numeric', month: 'long', year: 'numeric' });
  }
  function taPeriodDays(unit, value) { return unit === 'WEEK' ? value * 7 : unit === 'MONTH' ? value * 30 : value; }
  function taShippingDate(sd) {
    if (!sd || sd.type === 'NO_SET') return '';
    if (sd.type === 'DATE') return taFmtDate(sd.date);
    if (sd.type === 'PERIOD') { var d = new Date(); d.setDate(d.getDate() + taPeriodDays(sd.periodType, sd.periodValue)); return taFmtDate(d.getTime() / 1000); }
    if (sd.type === 'INTERVAL') {
      var a = new Date(); a.setDate(a.getDate() + taPeriodDays(sd.periodStart.type, sd.periodStart.value));
      var b = new Date(); b.setDate(b.getDate() + taPeriodDays(sd.periodEnd.type, sd.periodEnd.value));
      return taFmtDate(a.getTime() / 1000) + ' – ' + taFmtDate(b.getTime() / 1000);
    }
    return '';
  }
  function taDaysUntilShip(sd) {
    if (!sd || sd.type === 'NO_SET') return '';
    if (sd.type === 'DATE') return Math.ceil((sd.date * 1000 - Date.now()) / 86400000);
    if (sd.type === 'PERIOD') return taPeriodDays(sd.periodType, sd.periodValue);
    if (sd.type === 'INTERVAL') return taPeriodDays(sd.periodEnd.type, sd.periodEnd.value);
    return '';
  }
  function taResolveMessage(raw, ve) {
    var cfg = ve.config || {};
    var sd = cfg.shippingDate;
    var qty = (cfg.stock && !cfg.stock.hasUnlimitedQuantity) ? cfg.stock.quantity : '';
    var endLeft = cfg.hasEndDate ? Math.ceil((cfg.endDate * 1000 - Date.now()) / 86400000) : '';
    return String(raw)
      .replace(/\{\{preorderQuantity\}\}/g, qty)
      .replace(/\{\{shippingDate\}\}/g, taShippingDate(sd))
      .replace(/\{\{daysLeftUntilShippingDate\}\}/g, taDaysUntilShip(sd))
      .replace(/\{\{daysLeftUntilPreorderEndDate\}\}/g, endLeft);
  }

  function initPreorder(root) {
    var slot = root.querySelector('[data-rd-preorder]');
    if (!slot) return;
    var msgEl = slot.querySelector('[data-rd-preorder-msg]');
    var pid = slot.getAttribute('data-rd-pid');
    var idInput = root.querySelector('[name="id"]');

    function render() {
      var prods = taParse('products');
      var settings = taParse('settings');
      var vid = idInput ? idInput.value : '';
      var ve = taVariantConfig(prods, pid, vid);
      // Aktive Vorbestellung = PO-Status ACTIVE (NO_STOCK = ausverkauft, kein Hinweis).
      var active = !!(ve && ve.config && ve.config.status === 'ACTIVE' && ve.isPOEnabled !== false);
      var tpl = active && settings ? settings[ve.config.settingsTemplate] : null;
      var raw = tpl && tpl.message ? tpl.message.value : '';
      if (!raw) { if (!slot.classList.contains('rd-preorder--reserve')) slot.hidden = true; return false; }
      msgEl.innerHTML = taResolveMessage(raw, ve);
      slot.hidden = false;
      return true;
    }

    root.__rdPreorder = render;
    // Timesact lädt seine Config asynchron (App-Proxy → localStorage) während dieses
    // Seitenaufrufs. Sofort versuchen, sonst kurz pollen, bis die Daten vorliegen.
    if (!render()) {
      var tries = 0;
      var iv = setInterval(function () { tries++; if (render() || tries >= 12) clearInterval(iv); }, 400);
    }
  }

  function initRoot(root) {
    if (root.dataset.rdInit === '1') return;
    root.dataset.rdInit = '1';

    /* --- Hero gallery --- */
    var heroImg = root.querySelector('#rd-hero-img');
    var thumbs = root.querySelectorAll('[data-rd-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-rd-src');
        if (heroImg && src) {
          heroImg.removeAttribute('srcset');
          heroImg.src = src;
        }
        thumbs.forEach(function (t) { t.removeAttribute('aria-current'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });

    /* --- Quantity stepper + live total --- */
    var qtyVal = root.querySelector('[data-rd-qty-val]');
    var qtyInput = root.querySelector('[data-rd-qty-input]');
    var totalEl = root.querySelector('[data-rd-total]');
    var addBtn = root.querySelector('[data-rd-price-cents]');
    var unitCents = addBtn ? parseInt(addBtn.getAttribute('data-rd-price-cents'), 10) || 0 : 0;
    var qty = 1;

    function render() {
      if (qtyVal) qtyVal.textContent = String(qty);
      if (qtyInput) qtyInput.value = String(qty);
      if (totalEl && unitCents > 0) totalEl.textContent = euro(unitCents * qty);
    }

    var dec = root.querySelector('[data-rd-qty-dec]');
    var inc = root.querySelector('[data-rd-qty-inc]');
    if (dec) dec.addEventListener('click', function () { if (qty > 1) { qty--; render(); } });
    if (inc) inc.addEventListener('click', function () { if (qty < 99) { qty++; render(); } });
    render();

    /* --- Desktop in-card qty stepper (native number input) --- */
    var dq = root.querySelector('[data-rd-deskqty-input]');
    if (dq) {
      var clampDq = function () {
        var min = parseInt(dq.min, 10) || 1;
        var max = dq.max ? parseInt(dq.max, 10) : 9999;
        var val = parseInt(dq.value, 10);
        if (isNaN(val) || val < min) val = min;
        if (val > max) val = max;
        dq.value = String(val);
      };
      var ddec = root.querySelector('[data-rd-deskqty-dec]');
      var dinc = root.querySelector('[data-rd-deskqty-inc]');
      if (ddec) ddec.addEventListener('click', function () { dq.value = String((parseInt(dq.value, 10) || 1) - 1); clampDq(); });
      if (dinc) dinc.addEventListener('click', function () { dq.value = String((parseInt(dq.value, 10) || 1) + 1); clampDq(); });
      dq.addEventListener('change', clampDq);
    }

    /* --- Variant picker (self-contained; keeps Canopy's <product-form>) --- */
    var variantsEl = root.querySelector('[data-rd-variants]');
    if (variantsEl) {
      var variants = [];
      try { variants = JSON.parse(variantsEl.textContent) || []; } catch (e) { variants = []; }
      var variantInputs = root.querySelectorAll('[data-rd-variant-input]');
      var priceEl = root.querySelector('[data-rd-price]');
      var compareEl = root.querySelector('[data-rd-compare]');
      var saveEl = root.querySelector('[data-rd-save]');
      var saveamtEl = root.querySelector('[data-rd-saveamt]');
      var ctaSpan = addBtn ? addBtn.querySelector('span') : null;
      var stickyTitle = root.querySelector('[data-rd-sticky-title]');
      var stockEl = root.querySelector('[data-rd-stock]');
      var groups = root.querySelectorAll('[data-rd-variants-ui] [data-rd-option-index]');

      function selectedOptions() {
        var opts = [];
        groups.forEach(function (g) {
          var idx = parseInt(g.getAttribute('data-rd-option-index'), 10);
          var checked = g.querySelector('input[type="radio"]:checked');
          opts[idx] = checked ? checked.value : null;
        });
        return opts;
      }
      function findVariant(opts) {
        return variants.filter(function (v) {
          return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
        })[0];
      }
      function applyVariant(v) {
        if (!v) return;
        variantInputs.forEach(function (i) { i.value = v.id; });
        unitCents = v.price;
        if (priceEl) priceEl.textContent = euro(v.price);
        // Streichpreis + Ersparnis bei reduzierter Variante mitziehen
        var saleOn = v.compare_at && v.compare_at > v.price && v.compare_at <= v.price * 20;
        if (priceEl) priceEl.classList.toggle('rd-price--sale', !!saleOn);
        if (compareEl) { compareEl.hidden = !saleOn; if (saleOn) { compareEl.textContent = euro(v.compare_at); } }
        if (saveEl) { saveEl.hidden = !saleOn; if (saleOn) { saveEl.textContent = '−' + Math.round((v.compare_at - v.price) / v.compare_at * 100) + ' %'; } }
        if (saveamtEl) { saveamtEl.hidden = !saleOn; if (saleOn) { saveamtEl.textContent = 'Du sparst ' + euro(v.compare_at - v.price) + ' · '; } }
        if (stickyTitle) stickyTitle.textContent = v.title;
        if (addBtn) addBtn.setAttribute('data-rd-price-cents', String(v.price));
        // Sync availability + label across ALL add buttons (sticky + desktop in-card)
        root.querySelectorAll('[data-rd-add]').forEach(function (btn) {
          btn.disabled = !v.available;
          var sp = btn.querySelector('span');
          if (sp) sp.textContent = v.available ? (btn.getAttribute('data-rd-label-add') || 'Hinzufügen') : 'Ausverkauft';
        });
        if (stockEl) {
          if (v.tracked && v.qty > 0) {
            stockEl.hidden = false;
            stockEl.classList.remove('rd-stock--out');
            stockEl.title = v.qty + ' Stück sofort versandbereit.' + (v.oversell ? ' Größere Mengen max. 14 Tage.' : '');
            stockEl.innerHTML = '<span class="rd-stock__dot"></span>' + v.qty + ' verfügbar';
          } else if (!v.available) {
            stockEl.hidden = false;
            stockEl.classList.add('rd-stock--out');
            stockEl.removeAttribute('title');
            stockEl.innerHTML = '<span class="rd-stock__dot"></span>Ausverkauft';
          } else {
            stockEl.hidden = true;
          }
        }
        var deskQtyMax = root.querySelector('[data-rd-deskqty-input]');
        if (deskQtyMax) { if (v.tracked && v.qty > 0) { deskQtyMax.max = v.qty; } else { deskQtyMax.removeAttribute('max'); } }
        if (heroImg && v.image) { heroImg.removeAttribute('srcset'); heroImg.src = v.image; }
        render();
        if (root.__rdPreorder) root.__rdPreorder(); // Vorbestell-Hinweis pro Variante
      }
      root.querySelectorAll('[data-rd-variants-ui] input[type="radio"]').forEach(function (r) {
        r.addEventListener('change', function () { applyVariant(findVariant(selectedOptions())); });
      });
    }

    /* --- Cross-sell via Shopify product recommendations (intent: related) --- */
    var reco = root.querySelector('[data-rd-reco]');
    if (reco && 'fetch' in window) {
      var recoUrl = reco.getAttribute('data-rd-reco-url');
      var recoPid = reco.getAttribute('data-rd-reco-pid');
      var recoLimit = parseInt(reco.getAttribute('data-rd-reco-limit'), 10) || 3;
      var recoGrid = reco.querySelector('[data-rd-reco-grid]');
      if (recoUrl && recoPid && recoGrid) {
        fetch(recoUrl + '.json?product_id=' + recoPid + '&intent=related&limit=' + recoLimit)
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            var products = (data && data.products) || [];
            if (!products.length) return;
            recoGrid.innerHTML = products.map(function (pr) {
              var href = pr.url || ('/products/' + pr.handle);
              var img = pr.featured_image
                ? '<img src="' + sizedImage(pr.featured_image, 300) + '" loading="lazy" class="rd-cross__img" alt="' + escapeHtml(pr.title) + '">'
                : '';
              return '<a href="' + href + '" class="rd-cross__tile">' + img +
                '<div class="rd-cross__name">' + escapeHtml(truncateWords(pr.title, 6)) + '</div>' +
                '<div class="rd-cross__price">' + euro(pr.price) + '</div></a>';
            }).join('');
            reco.hidden = false;
          })
          .catch(function () {});
      }
    }

    /* --- Step timeline focus (visual only) --- */
    var steps = root.querySelectorAll('[data-rd-step]');
    steps.forEach(function (step) {
      step.addEventListener('click', function () {
        steps.forEach(function (s) { s.removeAttribute('aria-current'); });
        step.setAttribute('aria-current', 'true');
      });
    });

    /* --- "Weiterlesen" toggle (only when the text actually overflows) --- */
    var lead = root.querySelector('[data-rd-lead]');
    var more = root.querySelector('[data-rd-more]');
    if (lead && more) {
      requestAnimationFrame(function () {
        if (lead.scrollHeight - lead.clientHeight > 4) {
          more.hidden = false;
        }
      });
      more.addEventListener('click', function () {
        var open = lead.classList.toggle('rd-about__lead--open');
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.firstChild.nodeValue = open ? 'Weniger anzeigen' : 'Weiterlesen';
      });
    }

    /* --- Reviews swiper arrows --- */
    var revs = root.querySelector('[data-rd-reviews]');
    function scrollReviews(dir) {
      if (!revs) return;
      var card = revs.querySelector('.rd-review');
      var step = card ? card.getBoundingClientRect().width + 12 : revs.clientWidth * 0.8;
      revs.scrollBy({ left: dir * step, behavior: 'smooth' });
    }
    var rPrev = root.querySelector('[data-rd-rev-prev]');
    var rNext = root.querySelector('[data-rd-rev-next]');
    if (rPrev) rPrev.addEventListener('click', function () { scrollReviews(-1); });
    if (rNext) rNext.addEventListener('click', function () { scrollReviews(1); });

    initPreorder(root);
  }

  function init() {
    document.querySelectorAll('.rd-pdp').forEach(function (pdp) {
      var root = pdp.closest('[data-section-id]') || pdp;
      initRoot(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when the theme editor re-renders the section.
  document.addEventListener('shopify:section:load', init);

  /* --- Judge.me featured carousel: click a review to expand/collapse its full
     text. Judge.me renders the carousel asynchronously, so use one delegated
     document-level listener (robust regardless of render timing). Clicks on the
     arrows or inner links keep their own behaviour. The CSS handles the visual
     un-clamp + lets the card and carousel grow (.rd-jdgm-open / .rd-jdgm-has-open). */
  document.addEventListener('click', function (e) {
    var review = e.target.closest && e.target.closest('.jdgm-carousel-item__review');
    if (!review) return;
    if (e.target.closest('a, .jdgm-carousel__left-arrow, .jdgm-carousel__right-arrow')) return;
    var item = review.closest('.jdgm-carousel-item');
    if (!item) return;
    item.classList.toggle('rd-jdgm-open');
    var carousel = review.closest('.jdgm-carousel');
    if (carousel) {
      carousel.classList.toggle('rd-jdgm-has-open', !!carousel.querySelector('.jdgm-carousel-item.rd-jdgm-open'));
    }
  });
})();
